import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-desktop",
  "use": "icon-desktop-usage",
  "viewBox": "0 0 1098 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1098 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-desktop\"><defs><style type=\"text/css\"></style></defs><path d=\"M1044.041143 0 53.101714 0C23.771429 0 0 24.576 0 54.857143L0 731.428571C0 761.709714 43.812571 804.571429 73.142857 804.571429L438.857143 804.571429 438.857143 950.857143 292.571429 1024 318.537143 1024 778.605714 1024 804.571429 1024 658.285714 950.857143 658.285714 804.571429 1024 804.571429C1053.330286 804.571429 1097.142857 761.709714 1097.142857 731.428571L1097.142857 54.857143C1097.142857 24.576 1073.371429 0 1044.041143 0L1044.041143 0 1044.041143 0 1044.041143 0ZM1024 731.428571 73.142857 731.428571 70.802286 73.142857 1026.340571 73.142857 1024 731.428571 1024 731.428571 1026.340571 694.857143 1024 731.428571Z\" p-id=\"2547\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/desktop.svg
// module id = OI8q
// module chunks = 197